import React from 'react';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../../redux/store';
import { connect } from 'react-redux';
import { Auftrag, Waehrung } from '../../../../../api';
import {
  setBic,
  setIban,
  setNachnahmebetrag,
  setNachnahmebetragWaehrung,
} from '../../../../../redux/actions/auftragserfassung';
import Form from '../../../../../components/form/Form';
import InputFieldCurrency from '../../../../../components/input/floating-label/input-field/InputFieldCurrency';
import InputFieldText from '../../../../../components/input/floating-label/input-field/InputFieldText';
import InputFieldIBAN from '../../../../../components/input/floating-label/input-field/InputFieldIBAN';

import { nameof } from '../../../../../utils/objectUtils';
import {
  removeNotifications,
  setNotification,
} from '../../../../../utils/notificationUtils';
import { FORM_VALIDATION } from '../../../../notification/Notification';
import IBAN from 'iban';
import { ConfigModel } from '../../../../../models/ConfigModel';
import { toSelectOptions } from '../../../../../components/select/SelectModel';
import Select from '../../../../../components/select/Select';
import { WaehrungModel } from '../../../../../models/WaehrungModel';

interface NachnahmeProps {
  auftragserfassung: StateModel_Auftragserfassung;
  setIban: (value: string | undefined) => void;
  setBic: (value: string | undefined) => void;
  setNachnahmebetrag: (value: string | undefined) => void;
  setNachnahmebetragWaehrung: (value: WaehrungModel | undefined) => void;
  config: ConfigModel;
  waehrungen: WaehrungModel[];
}

const getDefaultWaehrung = (props: NachnahmeProps): Waehrung | null => {
  let selectedWaehrung: Waehrung | undefined;
  if (props.config.defaultWaehrung) {
    const id = props.config.defaultWaehrung;
    if (id) {
      selectedWaehrung = props.waehrungen.find(
        waehrung => waehrung.id === Number(id)
      );
    }
  }

  if (!selectedWaehrung) {
    //Dann DEFAULT 2 =€ nehmen.
    selectedWaehrung = props.waehrungen.find(waehrung => waehrung.id === 2);
  }
  props.auftragserfassung.nachnahmeWaehrung = selectedWaehrung;
  return selectedWaehrung || null;
};

const NachnahmeWrapper = (props: NachnahmeProps) => {
  if (!props.auftragserfassung.nachnahmeWaehrung) getDefaultWaehrung(props); //85617 sonst knallt es bei BEXity

  const onBlurHandler = (value: string) => {
    if (isBexity) {
      removeNotifications();
      if (value && !IBAN.isValid(value)) {
        setNotification(
          'Bitte eine gültige IBAN eingeben.',
          [],
          FORM_VALIDATION,
          null,
          'iban'
        );
      }
    }
  };
  const isBexity = props.config.clientKunde?.toUpperCase() === 'BEXITY';

  if (isBexity) {
    return (
      <Form classes='nachnahme'>
        <div id='iban'>
          <InputFieldIBAN
            label='IBAN'
            name={nameof<Auftrag>('iban')}
            classes='iban'
            maxlength={39}
            tooltip={'DE00 0000 0000 0000 0000 00'}
            onChangeHandler={props.setIban}
            onBlurHandler={onBlurHandler}
            value={props.auftragserfassung.iban}
          />
          <InputFieldText
            label='BIC'
            classes='bic'
            onChangeHandler={props.setBic}
            value={props.auftragserfassung.bic}
          />
        </div>
        <InputFieldCurrency
          resetValue={''}
          label='Betrag'
          classes='betrag'
          onChangeHandler={props.setNachnahmebetrag}
          value={props.auftragserfassung.nachnahmeBetrag ?? ''}
          currency={'€'}
        />
      </Form>
    );
  } else
    return (
      <Form classes='nachnahme'>
        <InputFieldCurrency
          resetValue={''}
          label='Betrag'
          classes='betrag'
          onChangeHandler={props.setNachnahmebetrag}
          value={props.auftragserfassung.nachnahmeBetrag ?? ''}
        />
        <Select
          className='waehrung'
          headerTitle='Währung'
          name={nameof<Waehrung>('bezeichnungKurz')}
          onChangeHandler={option => {
            const selectedWaehrung = props.waehrungen.find(
              waehrung => waehrung.id === option
            );
            if (selectedWaehrung) {
              props.setNachnahmebetragWaehrung(selectedWaehrung);
            }
          }}
          selectedOptionId={
            props.auftragserfassung.nachnahmeWaehrung?.id ??
            getDefaultWaehrung(props)?.id ??
            -1
          }
          selectData={toSelectOptions(
            props.waehrungen,
            nameof<Waehrung>('bezeichnungKurz'),
            false,
            true
          )}
        />
      </Form>
    );
};
const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
  config: state.Config,
  waehrungen: state.Stammdaten.waehrungen,
});

export default connect(mapStateToProps, {
  setIban,
  setBic,
  setNachnahmebetrag,
  setNachnahmebetragWaehrung,
})(NachnahmeWrapper);
